// extracted by mini-css-extract-plugin
export default {"label":"EditableLabel_label__qK6OZ"};